export const ANALYTICS_SETUP_LINK =
  "https://guide.isomer.gov.sg/analytics-and-tracking/google-analytics"
export const TERMS_OF_USE_LINK =
  "https://guide.isomer.gov.sg/terms-and-privacy/terms-of-use"
export const PRIVACY_POLICY_LINK =
  "https://guide.isomer.gov.sg/terms-and-privacy/privacy-statement"
export const ISOMER_GUIDE_LINK = "https://guide.isomer.gov.sg/"
export const IDENTITY_GUIDE_LINK = "https://go.gov.sg/isomer-identity"
export const ISOMER_REPORT_ISSUE_LINK = "https://go.gov.sg/isomer-issue"
